import styled from "styled-components";

const PartnershipStyles = styled.div`
  .body-text {
    margin: 0 auto;
    margin-bottom: 20px;
    max-width: 1000px;
    padding: 0px 50px;
  }

  .partner {
    &-icon-section {
      display: flex;
      flex-direction: column;
      align-items: center;
      text-align: center;
      margin: 80px 0;
      background-color: #c0c9bd;
      padding: 60px 0;
    }

    &-icons-and-text {
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: flex-start;
      margin: 40px 0 0;
    }

    &-header {
      font-family: var(--header-font);
      font-weight: normal !important;
      font-size: 32px;
      line-height: 38px;
    }

    &-desc {
      font-size: 18px;
      line-height: 24px;
      /* line-height: 28px; */
    }

    &-sub-section-header {
      text-align: center;
      font-family: var(--header-font);
      font-weight: normal !important;
      font-size: 32px;
      line-height: 38px;
      margin-bottom: 24px;
    }

    &-caption {
      width: 100%;
      font-size: 14px;
      line-height: 18px;
      color: var(--medium-gray);
      padding-top: 6px;
    }

    &-img {
      height: 600px;
      width: 920px;
    }
  }

  .icon-and-text {
    width: 340px;
    display: flex;
    flex-direction: column;
    align-items: center;

    div {
      background-color: var(--neon-yellow);
      padding: 10px;
      border-radius: 100px;
      height: 70px;
      width: 70px;
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      margin-bottom: 20px;
    }

    svg {
      height: 40px;
      width: 40px;
    }
  }

  .case-studies,
  .lets-discuss {
    margin-top: 80px !important;
    width: 920px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .logo-and-name {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    margin-bottom: 16px;
  }

  .case-study-name {
    font-family: var(--header-font);
    font-weight: normal !important;
    font-size: 28px;
    line-height: 36px;
    margin-left: 12px;
  }

  .partner-logo {
    height: 40px;
    width: 40px;

    &--ING {
      height: 35px;
      width: 55px;
    }
  }

  .lets-discuss {
    margin-bottom: 80px;
  }

  @media only screen and (max-width: 1040px) {
    .case-studies {
      width: 540px;
    }

    .partner {
      &-icons-and-text {
        flex-direction: column;
      }

      &-img {
        width: 540px;
        height: 350px;
      }
    }

    .icon-and-text {
      width: 100%;
      margin-bottom: 50px;

      &:last-child {
        margin-bottom: 0;
      }

      p {
        max-width: 200px;
      }
    }

    .lets-discuss {
      width: 540px;
      text-align: center;
    }
  }

  @media only screen and (max-width: 650px) {
    .body-text {
      padding: 0 12px;
    }

    .partner {
      &-img {
        width: 100%;
      }
    }

    .services {
      padding: 0 12px;
    }

    .case-studies,
    .lets-discuss {
      width: 100%;
      padding: 0 12px;
    }
  }
`;

export default PartnershipStyles;
